import { Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import { routes } from './routes';
import './App.css';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { customPlugins } from './plugins';
import TurnstileGuard from './pages/TurnstileGuard.jsx';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    annotationPlugin,
    Title,
    Tooltip,
    Legend,
    ...customPlugins
);
function App() {
    return (
        <div className="app">
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </div>
    );
}

const AppRoutes = () => {
    const { bootstrapped, loading } = useAuth();

    if (!bootstrapped || loading) {
        return null;
    }

    return (
        <Routes>
            {routes.map((route, index) => {
                if (route.children) {
                    return (
                        <Route
                            key={index}
                            path={route.path}
                            element={<ProtectedRoute>{route.element}</ProtectedRoute>}
                        >
                            {route.children.map((child, childIndex) => (
                                <Route
                                    key={childIndex}
                                    path={child.path}
                                    index={child.index}
                                    element={child.element}
                                />
                            ))}
                        </Route>
                    );
                }
                return <Route key={index} path={route.path} element={route.element} />;
            })}
            <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>
    );
};

export default App;
